module.exports = __webpack_public_path__ + "img/abia.163cb92a.png";